import styled from '@emotion/styled'
import { type Styles } from 'react-select'
import { type Styles as ModalStyles } from 'react-modal'
import { type Theme, spacing } from '@instacart/ids-core'
import { Button, fontSize, fontWeight, ModalFooter } from '@retailer-platform/shared-components'

export const useSelectStyles = ({ theme }: { theme: Theme }): Styles => ({
  container: () => ({
    width: '100%',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
  }),
  control: styles => ({
    ...styles,
    margin: `${spacing.s12}px ${spacing.s16}px`,
    padding: `0 ${spacing.s12}px`,
    backgroundColor: theme.colors.systemGrayscale10,
    border: 'none',
    boxShadow: 'none',
    minHeight: '40px',
    borderRadius: theme.radius.r8,
    ':hover': {
      boxShadow: `0 0 0 2px ${theme.colors.systemGrayscale70}`,
    },
    ':focus': {
      boxShadow: `0 0 0 2px ${theme.colors.systemGrayscale70}`,
    },
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  menu: () => ({
    width: '100%',
    border: 'none',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
    flex: 1,
  }),
  menuList: styles => ({
    ...styles,
    flex: 1,
    maxHeight: 'none',
    borderTop: `1px solid ${theme.colors.systemGrayscale20}`,
    overflowY: 'scroll',
  }),
  option: styles => ({
    ...styles,
    padding: `${spacing.s8}px ${spacing.s24}px`,
    backgroundColor: theme.colors.systemGrayscale00,
    ':hover': {
      backgroundColor: theme.colors.systemGrayscale20,
    },
  }),
  placeholder: styles => ({
    ...styles,
    fontSize: fontSize.X15,
    fontWeight: fontWeight.SEMIBOLD,
    lineHeight: '22px',
    color: theme.colors.systemGrayscale70,
  }),
})

export const modalStyles: ModalStyles = {
  content: {
    height: '600px',
    display: 'flex',
    flexDirection: 'column',
  },
}

export const StyledModalFooter = styled(ModalFooter)({
  columnGap: spacing.s16,
})

export const StyledButton = styled(Button)({
  marginLeft: 0,
  marginRight: 0,
})
